// Lightweight utility for combining classNames
export function cn(...inputs) {
  return inputs
    .flat(Infinity)
    .filter(Boolean)
    .join(" ");
}

export function formatVND(value) {
  if (value == null || isNaN(value)) return "0₫";
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDate(value) {
  if (!value) return "";
  const d = new Date(value);
  const vn = new Date(d.getTime() + 7 * 60 * 60 * 1000);
  return vn.toLocaleDateString("vi-VN", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function formatDateTime(value) {
  if (!value) return "";
  const d = new Date(value);
  const vn = new Date(d.getTime() + 7 * 60 * 60 * 1000);
  return vn.toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function timeAgo(value, lang = "vi") {
  if (!value) return "";
  const d = new Date(value);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return lang === "vi" ? "vừa xong" : "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}${lang === "vi" ? " phút trước" : "m ago"}`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}${lang === "vi" ? " giờ trước" : "h ago"}`;
  return formatDate(value);
}

/**
 * Chuyển lỗi từ API (axios) thành string an toàn để hiển thị trong toast/UI.
 * Xử lý cả Pydantic v2 validation errors (detail là array of objects).
 *
 * @param {any} err - đối tượng lỗi từ catch
 * @param {string} fallback - chuỗi mặc định nếu không parse được
 * @returns {string}
 */
export function parseApiError(err, fallback = "Đã có lỗi xảy ra") {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;

  // Pydantic v2: detail là array of {type, loc, msg, input, url}
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        const field = Array.isArray(d.loc) ? d.loc.filter((x) => x !== "body").join(".") : "";
        const msg = d.msg || d.message || JSON.stringify(d);
        return field ? `${field}: ${msg}` : msg;
      })
      .join(" | ");
  }

  // Pydantic v1 / FastAPI: detail là string
  if (typeof detail === "string") return detail;

  // Object khác
  return JSON.stringify(detail);
}